<template>
    <FormCard>
        <template #cardTitle>
            ACCOUNT INFORMATION
        </template>
        <template #cardSubtitle>
            This is automatically filled-out by the system. If you think there are issues with these information, please contact <a href="https://www.hmi.com.ph/contact">HMI</a>.
        </template>
        <template #cardText>
            <v-text-field
                label="ACCOUNT:"
                :value="getInfo.ACCOUNT"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="EFFECTIVITY DATE:"
                :value="getInfo.EFF_DATE"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="MEMBERSHIP EXPIRY DATE:"
                :value="getInfo.LAST_D"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="ACCOUNT EXPIRY DATE:"
                :value="getInfo.ACC_EXP"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <!-- <v-text-field
                label="PAID UNTIL:"
                :value="getInfo.PD_UNTIL"
                color="teal"
                readonly
                autocomplete="nope"
            /> -->
            <v-text-field
                label="STATUS:"
                :value="getInfo.STATUS"
                color="teal"
                readonly
                autocomplete="nope"
            />
        </template>
    </FormCard>
</template>

<script>
import FormCard from './Other/FormCard.vue'
export default {
    components: {
        FormCard
    },
    props: ['getInfo']
}
</script>
